<template>
  <div
    class="container-fluid d-flex justify-content-center align-items-center bg-primary"
    style="height: 100vh"
  >
    <div
      class="card shadow-lg border-0 w-75"
      style="height: calc(100vh - 150px)"
    >
      <div class="row g-1" style="height: 100%">
        <!-- Login Panel -->
        <div
          class="col-md-6 d-flex justify-content-center align-items-center p-0"
        >
          <div class="col-sm-10 col-lg-7 col-11">
            <div class="text-center mb-4">
              <h3 class="font-weight-bolder fs-4">Inicio de Sesión CILARA</h3>
              <p>Atención este acceso es solo para administración CILARA</p>
            </div>
            <form @submit.prevent="OnSubmit" role="form">
              <div class="mb-3">
                <label class="form-label">Correo</label>
                <input
                  v-model="model.email"
                  type="email"
                  class="form-control border-info"
                  placeholder="Escribe tu correo"
                  aria-label="Email"
                  aria-describedby="email-addon"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Contraseña</label>
                <div class="input-group">
                  <input
                    v-model="model.password"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control border-info"
                    placeholder="Escribe tu contraseña"
                    aria-label="Password"
                    aria-describedby="password-addon"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-info text-info border-info py-0 px-3"
                      :class="{
                        'bi bi-eye-slash-fill': !showPassword,
                        'bi bi-eye-fill': showPassword
                      }"
                      type="button"
                      style="
                        border-radius: 0px 7px 7px 0px;
                        border-width: 1px;
                        border-left: 0px;
                      "
                      @click.prevent="toggleVisibility()"
                    ></button>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button
                  type="submit"
                  class="btn btn-fill btn-info mt-4 mb-4 w-100 font-weigh-normal"
                  style="border-radius: 8px"
                >
                  Acceder
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Image Panel -->
        <div class="login col-md-6 bg-primary p-0 rounded-right">
          <div
            class="gradient h-100 w-100 d-flex justify-content-center align-items-center rounded-right"
          >
            <img
              :src="require('@/assets/img/logo.png')"
              class="img-fluid img-shadow"
              alt="main_logo"
              style="z-index: 4; max-width: 70%; height: auto"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapActions } from 'vuex'
import validator from 'email-validator'

export default {
  name: 'Login',
  data() {
    return {
      showPassword: false,
      model: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions(['login']),
    toggleVisibility() {
      this.showPassword = !this.showPassword
    },

    OnSubmit() {
      if (this.model.email === '' || this.model.password === '') {
        Swal.fire({
          title: 'Atención',
          text: 'Complete todos los campos para continuar',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn-info'
          }
        })
        return
      }

      if (!validator.validate(this.model.email)) {
        Swal.fire({
          title: 'Atención',
          text: 'El correo electrónico no es válido',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn-info'
          }
        })
        return
      }

      Swal.showLoading()
      this.login(this.model)
        .then((response) => {
          if (response.code === 200) {
            this.$router.push('/admin/overview')
            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            })
            Toast.fire({
              icon: 'success',
              title: '¡Bienvenido!',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (response.code === 403) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Este usuario no puede acceder al panel administrativo',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (response.code === 402) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else {
            Swal.fire({
              title: 'Ocurrió un error',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.code === 402) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (error.code === 403) {
            Swal.fire({
              title: 'Credenciales inválidas',
              text: 'Este usuario no puede acceder al panel administrativo',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else if (error.code === 404) {
            Swal.fire({
              title: 'Usuario no encontrado',
              text: 'No se encuentra un usuario activo con estos datos',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          } else {
            Swal.fire({
              title: 'Ocurrió un error',
              text: 'Revisa tus credenciales, e intenta nuevamente',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn-info'
              }
            })
          }
        })
    }
  }
}
</script>

<style>
.login {
  background-size: cover;
  background-image: url('~@/assets/img/login.png');
}

.gradient {
  background: linear-gradient(135deg, #ffffff00 0%, #000000ad 100%);
}

.img-shadow {
  filter: drop-shadow(0 4px 4px rgba(3, 7, 29, 0.6));
}
</style>
